import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDisclosure } from '@mantine/hooks';
import { Collapse } from '@mantine/core';
import { IconChevronUp } from '@tabler/icons-react';
import classes from './box.module.css';

const Box = (props) => {
  const {
    title,
    footer,
    children,
    withBackground = false,
    withSpacing = true,
    withCollapse = false,
    startClose = false,
    onCollapseChange = () => { },
  } = props;

  const [opened, { toggle }] = useDisclosure(!startClose);

  const boxClasses = clsx(
    classes.box,
    withBackground && classes.background,
    withSpacing && classes.spacing,
  );

  const handleCollapseClick = () => {
    const result = onCollapseChange(opened);
    if (result !== false) {
      toggle();
    }
  };

  const titleElement = (title) ? <div className={classes.title}>{title}</div> : null;
  const collapseElement = (withCollapse)
    ? <div className={classes.action}><IconChevronUp /></div>
    : null;
  const headClassses = clsx(classes.head, withCollapse && classes.collapse);
  const headElement = (withCollapse)
    ? <button className={headClassses} onClick={handleCollapseClick}>
      {titleElement}{collapseElement}
    </button>
    : <div className={headClassses}>{titleElement}{collapseElement}</div>;
  const bodyClasses = clsx(
    classes.body,
    !opened && classes.noPadding,
  );
  const bodyElement = (withCollapse)
    ? <div className={bodyClasses}><Collapse in={opened}>{children}</Collapse></div>
    : <div className={bodyClasses}>{children}</div>;

  return (
    <div
      className={boxClasses}
      data-open={opened ? 'true' : 'false'}
      data-collapse={withCollapse ? 'true' : undefined}
    >
      {(withCollapse || title) && headElement}
      {bodyElement}
      {footer && <div className={classes.footer}>{footer}</div>}
    </div>
  );
};

Box.propTypes = {
  title: PropTypes.string,
  footer: PropTypes.any,
  children: PropTypes.any,
  withBackground: PropTypes.bool,
  withSpacing: PropTypes.bool,
  withCollapse: PropTypes.bool,
  startClose: PropTypes.bool,
  onCollapseChange: PropTypes.func,
};

export default Box;
